'use client';

import { createContext, type ReactNode, useContext } from 'react';

import { useTeamConfig } from '@/app/(football)/[team]/_context/context';

import { miniGamePageConfig } from './config';
import type { MiniGamePageConfig } from './types';

const MiniGamePageConfigContext = createContext<MiniGamePageConfig | null>(null);

interface Props {
  children: ReactNode;
}

export function MiniGamePageConfigProvider({ children }: Props) {
  const { teamSlug } = useTeamConfig();
  const config = miniGamePageConfig[teamSlug];

  return <MiniGamePageConfigContext.Provider value={config}>{children}</MiniGamePageConfigContext.Provider>;
}

export function useMiniGamePageConfig() {
  const context = useContext(MiniGamePageConfigContext);

  if (!context) {
    throw new Error('useMiniGamePageConfig must be used within MiniGamePageConfigProvider');
  }

  return context;
}
